// All events happen in NYC, so times are always shown in the venue's
// timezone — never the visitor's. Event timestamps arrive as UTC instants.
const EVENT_TIME_ZONE = 'America/New_York';

function getParts(date: Date): Record<string, string> {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: EVENT_TIME_ZONE,
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).formatToParts(date);

  const result: Record<string, string> = {};
  for (const part of parts) {
    result[part.type] = part.value;
  }
  return result;
}

/**
 * Format an ISO date string to a readable format, in the venue's timezone
 * @param isoString - ISO date string
 * @returns Formatted date string (e.g., "THU, JAN 23 · 8:00 PM")
 */
export function formatDate(isoString: string): string {
  const p = getParts(new Date(isoString));
  return `${p.weekday.toUpperCase()}, ${p.month.toUpperCase()} ${p.day} · ${p.hour}:${p.minute} ${p.dayPeriod.toUpperCase()}`;
}

/**
 * Format an ISO date string to a time-only format, in the venue's timezone
 * @param isoString - ISO date string
 * @returns Formatted time string (e.g., "8:00 PM - 10:00 PM")
 */
export function formatTimeRange(startIso: string, endIso: string): string {
  const formatTime = (iso: string) => {
    const p = getParts(new Date(iso));
    return `${p.hour}:${p.minute} ${p.dayPeriod.toUpperCase()}`;
  };

  return `${formatTime(startIso)} - ${formatTime(endIso)}`;
}
